module.exports = __webpack_public_path__ + "img/pic_logo@2x.a2ace455.png";